import { Box, type BoxProps } from '@mui/material';
import { forwardRef } from 'react';
import * as Styled from './styles';

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  full?: boolean;
  src?: string;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, full, src, ...other }, ref) => {
    const img = (
      <Styled.Img src={src ?? 'assets/images/ark-logo.svg'} alt="logo" />
    );

    return (
      <Box
        ref={ref}
        component="div"
        sx={{
          height: 40,
          width: '100%',
          display: 'inline-flex',
          ...sx,
        }}
        {...other}
      >
        {disabledLink ? img : <Styled.Link to="/">{img}</Styled.Link>}
      </Box>
    );
  }
);

export default Logo;
